import React from 'react'
import { connect } from 'react-redux'

import Titulo from '../comum/Titulo'
import Autorizacao from '../../security/Autorizacao'
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorEmpresa, getOperadorRemarcacao } from '../../security/securityContext'
import buscarEncomendasAvulsas from '../../actions/encomendaAvulsa/buscarEncomendasAvulsas'
import buscarEncomendaAvulsaPorId from '../../actions/encomendaAvulsa/buscarEncomendaAvulsaPorId'
import cancelarEncomendaAvulsa from '../../actions/encomendaAvulsa/cancelarEncomendaAvulsa'
import informarEntregaEncomendaAvulsa from '../../actions/encomendaAvulsa/informarEntregaEncomendaAvulsa'
import ModalConfirmacaoCancelamentoEncomendaAvulsa from './ModalConfirmacaoCancelamentoEncomendaAvulsa'
import ModalInformarEntregaEncomendaAvulsa from './ModalInformarEntregaEncomendaAvulsa'
import { showErrorMsg } from '../../util/messagesUtil'

const OPCOES_SITUACAO = [
  // venda via Sicoob PIX aguardando a confirmação do pagamento
  { cod: 'PENDENTE', label: 'Pendente' },
  { cod: 'VENDIDA', label: 'Vendida' },
  { cod: 'EM_TRANSITO', label: 'Em trânsito' },
  { cod: 'DISPONIVEL_PARA_ENTREGA', label: 'Disponível para entrega' },
  { cod: 'ENTREGUE', label: 'Entregue' },
  { cod: 'CANCELADA', label: 'Cancelada' }
]

const OPCOES_REGISTROS_POR_PAGINA = [10, 20, 50, 100]

const FILTRO_INICIAL = {
  numeroOs: '', numeroPedido: '', vendedor: '', descricao: '', remetente: '', destinatario: '',
  situacao: '', valorMinimo: '', valorMaximo: ''
}

function corBadge (situacao) {
  if (situacao === 'CANCELADA') return 'vx-badge-danger'
  if (situacao === 'ENTREGUE') return 'vx-badge-success'
  if (situacao === 'PENDENTE') return 'vx-badge-warning'
  return 'vx-badge-info'
}

export class PainelGerenciarEncomendasAvulsas extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      filtro: { ...FILTRO_INICIAL },
      paginaAtual: 1,
      registrosPorPagina: 20,
      encomendaParaCancelar: null,
      encomendaParaEntregar: null
    }
  }

  componentDidMount () {
    this.buscar()
  }

  buscar () {
    const { filtro, paginaAtual, registrosPorPagina } = this.state
    this.props.buscarEncomendasAvulsas(this.props.empresaSelecionada.id, {
      ...filtro,
      from: paginaAtual,
      size: registrosPorPagina
    })
  }

  buscarDoInicio () {
    this.setState({ paginaAtual: 1 }, () => this.buscar())
  }

  irParaPagina (pagina) {
    this.setState({ paginaAtual: pagina }, () => this.buscar())
  }

  alterarRegistrosPorPagina (valor) {
    this.setState({ registrosPorPagina: Number(valor), paginaAtual: 1 }, () => this.buscar())
  }

  limparFiltros () {
    this.setState({ filtro: { ...FILTRO_INICIAL }, paginaAtual: 1 }, () => this.buscar())
  }

  alterarFiltro (campo, valor) {
    this.setState({ filtro: { ...this.state.filtro, [campo]: valor } })
  }

  imprimirCupom (encomenda) {
    this.props.buscarEncomendaAvulsaPorId(encomenda.id, this.props.empresaSelecionada.id).then(() => {
      this.props.history.push('/recibo-encomenda-avulsa')
    })
  }

  abrirCancelamento (encomenda) {
    this.setState({ encomendaParaCancelar: encomenda })
  }

  confirmarCancelamento (motivo) {
    const encomenda = this.state.encomendaParaCancelar
    this.props.cancelarEncomendaAvulsa({
      idEmpresa: this.props.empresaSelecionada.id,
      idEncomendaAvulsa: encomenda.id,
      motivo
    }).then(() => {
      this.setState({ encomendaParaCancelar: null })
      this.buscar()
    }).catch(erro => {
      if (!navigator.onLine || !erro.response) {
        showErrorMsg('Sem conexão com a internet. Não é possível cancelar encomendas avulsas offline.')
        return
      }
      throw erro
    })
  }

  abrirInformarEntrega (encomenda) {
    this.setState({ encomendaParaEntregar: encomenda })
  }

  confirmarEntrega (dados) {
    const encomenda = this.state.encomendaParaEntregar
    this.props.informarEntregaEncomendaAvulsa({
      idEmpresa: this.props.empresaSelecionada.id,
      idEncomendaAvulsa: encomenda.id,
      ...dados
    }).then(() => {
      this.setState({ encomendaParaEntregar: null })
      this.buscar()
    }).catch(erro => {
      if (!navigator.onLine || !erro.response) {
        showErrorMsg('Sem conexão com a internet. Não é possível informar entrega offline.')
        return
      }
      throw erro
    })
  }

  renderAcoes (encomenda, emp) {
    return (
      <div className="d-flex flex-wrap" style={{ gap: 6 }}>
        {/* igual a Emitir Cupom da reserva: pendente (Sicoob PIX não pago) não imprime cupom */}
        {encomenda.situacao !== 'PENDENTE' && (
          <button className="vx-btn-primary" onClick={() => this.imprimirCupom(encomenda)}>
            <i className="material-icons">print</i> Imprimir
          </button>
        )}
        {encomenda.sePodeInformarEntrega && (
          <button className="vx-btn-secondary" onClick={() => this.abrirInformarEntrega(encomenda)}>
            <i className="material-icons">local_shipping</i> Informar entrega
          </button>
        )}
        {encomenda.sePodeCancelar && (
          <Autorizacao
            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(emp.id), getOperadorEmpresa(emp.id), getOperadorRemarcacao(emp.id)]}
            empresaSelecionada={emp}
          >
            <button className="vx-btn-danger" onClick={() => this.abrirCancelamento(encomenda)}>
              <i className="material-icons">delete</i> Cancelar
            </button>
          </Autorizacao>
        )}
      </div>
    )
  }

  render () {
    const emp = this.props.empresaSelecionada
    const encomendasAvulsas = (this.props.encomendasAvulsas && this.props.encomendasAvulsas.encomendasAvulsas) || []
    const total = (this.props.encomendasAvulsas && this.props.encomendasAvulsas.total) || 0
    const { paginaAtual, registrosPorPagina } = this.state
    const totalPaginas = Math.max(1, Math.ceil(total / registrosPorPagina))
    const primeiroRegistro = total === 0 ? 0 : (paginaAtual - 1) * registrosPorPagina + 1
    const ultimoRegistro = Math.min(paginaAtual * registrosPorPagina, total)

    return (
      <div className="row internas">
        <Titulo texto="Encomenda Avulsa" urlRetorno="/dashboard"/>
        <div className="col-12">
          <p className="text-muted" style={{ marginTop: -12, marginBottom: 16 }}>
            Lista de encomendas avulsas vendidas vinculadas a itinerários.
          </p>
        </div>

        <div className="col-12">
          <div className="d-flex justify-content-end mb-3">
            <button className="vx-btn-primary" onClick={() => this.props.history.push('/painel-cadastro-encomenda-avulsa')}>
              <i className="material-icons">add</i> Vender encomenda avulsa
            </button>
          </div>

          <div className="vx-modal-section">
            <div className="vx-modal-section-title">
              <i className="material-icons">filter_list</i> Filtros de consulta
            </div>
            <div className="form-row">
              <div className="col-md-2 col-6">
                <label>Nº pedido</label>
                <input type="text" className="form-control" value={this.state.filtro.numeroPedido}
                       onChange={event => this.alterarFiltro('numeroPedido', event.target.value)}/>
              </div>
              <div className="col-md-2 col-6">
                <label>Nº OS</label>
                <input type="text" className="form-control" value={this.state.filtro.numeroOs}
                       onChange={event => this.alterarFiltro('numeroOs', event.target.value)}/>
              </div>
              <div className="col-md-2 col-6">
                <label>Vendedor</label>
                <input type="text" className="form-control" value={this.state.filtro.vendedor}
                       onChange={event => this.alterarFiltro('vendedor', event.target.value)}/>
              </div>
              <div className="col-md-3 col-6">
                <label>Descrição</label>
                <input type="text" className="form-control" value={this.state.filtro.descricao}
                       onChange={event => this.alterarFiltro('descricao', event.target.value)}/>
              </div>
              <div className="col-md-3 col-6">
                <label>Remetente</label>
                <input type="text" className="form-control" value={this.state.filtro.remetente}
                       onChange={event => this.alterarFiltro('remetente', event.target.value)}/>
              </div>
            </div>
            <div className="form-row mt-2">
              <div className="col-md-3 col-6">
                <label>Destinatário</label>
                <input type="text" className="form-control" value={this.state.filtro.destinatario}
                       onChange={event => this.alterarFiltro('destinatario', event.target.value)}/>
              </div>
              <div className="col-md-3 col-6">
                <label>Status</label>
                <select className="form-control" value={this.state.filtro.situacao}
                        onChange={event => this.alterarFiltro('situacao', event.target.value)}>
                  <option value="">Todos</option>
                  {OPCOES_SITUACAO.map(opcao => (
                    <option key={opcao.cod} value={opcao.cod}>{opcao.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 col-6">
                <label>Valor mínimo</label>
                <input type="text" className="form-control" value={this.state.filtro.valorMinimo}
                       onChange={event => this.alterarFiltro('valorMinimo', event.target.value)}/>
              </div>
              <div className="col-md-3 col-6">
                <label>Valor máximo</label>
                <input type="text" className="form-control" value={this.state.filtro.valorMaximo}
                       onChange={event => this.alterarFiltro('valorMaximo', event.target.value)}/>
              </div>
            </div>
            <div className="form-row mt-3">
              <div className="col-auto">
                <button className="vx-btn-primary" onClick={() => this.buscarDoInicio()}>
                  <i className="material-icons">search</i> Pesquisar
                </button>
              </div>
              <div className="col-auto">
                <button className="vx-btn-secondary" onClick={() => this.limparFiltros()}>
                  <i className="material-icons">refresh</i> Limpar filtros
                </button>
              </div>
            </div>
          </div>

          {/* Desktop: tabela */}
          <div className="vx-modal-section d-none d-md-block" style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Pedido</th>
                  <th>OS</th>
                  <th>Vendedor</th>
                  <th>Descrição</th>
                  <th>Remetente</th>
                  <th>Destinatário</th>
                  <th>Data venda</th>
                  <th>Status</th>
                  <th>Valor</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {encomendasAvulsas.map(encomenda => (
                  <tr key={encomenda.id}>
                    <td>{encomenda.numeroPedido}</td>
                    <td>{encomenda.numeroOs}</td>
                    <td>{encomenda.codigoVendedor} - {encomenda.nomeVendedor}</td>
                    <td>{encomenda.descricao}</td>
                    <td>{encomenda.nomeRemetente}</td>
                    <td>{encomenda.nomeDestinatario}</td>
                    <td>{encomenda.dataHoraVenda}</td>
                    <td><span className={`vx-badge ${corBadge(encomenda.situacao)}`}>{encomenda.descricaoSituacao}</span></td>
                    <td>R$ {encomenda.valor}</td>
                    <td>{this.renderAcoes(encomenda, emp)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {encomendasAvulsas.length === 0 && (
              <div className="text-muted text-center p-3">Nenhuma encomenda avulsa encontrada.</div>
            )}
          </div>

          {/* Mobile: cards */}
          <div className="d-md-none">
            {encomendasAvulsas.map(encomenda => (
              <div className="vx-modal-section mb-2" key={encomenda.id}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <strong>Pedido #{encomenda.numeroPedido}</strong>
                  <span className={`vx-badge ${corBadge(encomenda.situacao)}`}>{encomenda.descricaoSituacao}</span>
                </div>
                <div className="mb-1">Destinatário: {encomenda.nomeDestinatario}</div>
                <div className="mb-1">Data: {encomenda.dataHoraVenda}</div>
                <div className="mb-2">Valor: R$ {encomenda.valor}</div>
                {this.renderAcoes(encomenda, emp)}
              </div>
            ))}
            {encomendasAvulsas.length === 0 && (
              <div className="text-muted text-center p-3">Nenhuma encomenda avulsa encontrada.</div>
            )}
          </div>

          {encomendasAvulsas.length > 0 && (
            <div className="d-flex justify-content-between align-items-center flex-wrap mt-3" style={{ gap: 10 }}>
              <small className="text-muted">
                Mostrando {primeiroRegistro} a {ultimoRegistro} de {total} resultados
              </small>
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <div className="d-flex align-items-center" style={{ gap: 4 }}>
                  <button className="vx-btn-secondary" disabled={paginaAtual <= 1}
                          onClick={() => this.irParaPagina(paginaAtual - 1)}>
                    <i className="material-icons" style={{ fontSize: 15 }}>chevron_left</i>
                  </button>
                  <span style={{ fontSize: 13, padding: '0 6px' }}>{paginaAtual}</span>
                  <button className="vx-btn-secondary" disabled={paginaAtual >= totalPaginas}
                          onClick={() => this.irParaPagina(paginaAtual + 1)}>
                    <i className="material-icons" style={{ fontSize: 15 }}>chevron_right</i>
                  </button>
                </div>
                <select className="form-control" style={{ width: 'auto' }}
                        value={registrosPorPagina}
                        onChange={event => this.alterarRegistrosPorPagina(event.target.value)}>
                  {OPCOES_REGISTROS_POR_PAGINA.map(opcao => (
                    <option key={opcao} value={opcao}>{opcao} por página</option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>

        {this.state.encomendaParaCancelar && (
          <ModalConfirmacaoCancelamentoEncomendaAvulsa
            encomenda={this.state.encomendaParaCancelar}
            onFechar={() => this.setState({ encomendaParaCancelar: null })}
            onConfirmar={motivo => this.confirmarCancelamento(motivo)}
          />
        )}

        {this.state.encomendaParaEntregar && (
          <ModalInformarEntregaEncomendaAvulsa
            encomenda={this.state.encomendaParaEntregar}
            onFechar={() => this.setState({ encomendaParaEntregar: null })}
            onConfirmar={dados => this.confirmarEntrega(dados)}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  encomendasAvulsas: state.encomendasAvulsas
})

export default connect(mapStateToProps, {
  buscarEncomendasAvulsas,
  buscarEncomendaAvulsaPorId,
  cancelarEncomendaAvulsa,
  informarEntregaEncomendaAvulsa
})(PainelGerenciarEncomendasAvulsas)
